import React from 'react'
 import useSEO from "./useSEO";

const Ginesysaccounting = () => {

  useSEO({ 
  title: "Ginesys Accounting Software | Retail & ERP Accounting Solutions",
  description: "Optimize your retail and enterprise finances with Ginesys Accounting Software. Track sales, manage accounts, generate reports, and streamline GST compliance with ease.",
  keywords: "Ginesys accounting software, Ginesys ERP accounting, retail accounting software, GST billing software, Ginesys bookkeeping, POS accounting integration, Ginesys financial management, inventory and accounts software",
  ogTitle: "Ginesys Accounting Software - Smart Retail Accounting",
  ogDescription: "Manage accounts, sales, and compliance efficiently with Ginesys Accounting Software for retail and enterprises.",
  ogImage: "img/ginesys-accounting.png",
  twitterTitle: "Ginesys Accounting Software - Smart Retail Accounting",
  twitterDescription: "Retail-focused accounting, GST compliance, and financial management with Ginesys Accounting Software.",
  twitterImage: "img/ginesys-accounting.png"
});
  return (
    <div>
      <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> Ginesys Accounting Software</h1>
          <p className="mb-4">
            {" "}
            Ginesys Accounting Software is an all-in-one financial management
            solution designed to streamline accounting processes for businesses
            across retail industry. With its user-friendly interface and
            powerful features, Genisys simplifies everything from bookkeeping
            and invoicing to tax filing and financial reporting — enabling
            businesses to stay financially organized and compliant.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img
            src="img/ginesys-accounting-software.png"
            alt="Ginesys Accounting Software"
          />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img
              src="img/ginesys-accounting-software1.png"
              alt="Ginesys Accounting Software"
            />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4"> Key Features:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Complete Financial Management:</b>
                </li>
                <p>
                  Handle general ledger, accounts payable/receivable, bank
                  reconciliation, and expense tracking from one platform.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>GST-Ready &amp; Tax Compliant: </b>
                </li>
                <p>
                  Stay compliant with local tax laws, including GST filings and
                  automated tax calculations.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Real-Time Reporting:</b>
                </li>
                <p>
                  Generate accurate balance sheets, profit &amp; loss
                  statements, and custom reports for better business decisions.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Multi-User &amp; Role-Based Access:</b>
                </li>
                <p>
                  Control user access levels and collaborate securely within
                  your team.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Inventory Integration:</b>
                </li>
                <p>
                  Manage stock levels and link inventory directly with your
                  accounting data.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

    </div>
  )
}

export default Ginesysaccounting
